import React from 'react';
import Path from '../components/Path';
import About from '../blocks/about/About';
import Skills from '../blocks/about/Skills';
import Facts from '../blocks/about/Facts';

const AboutPage = ({ t, locale }) => {
  const skillsData = locale?.skills || {};
  
  return (
    <>
      <Path description={t.description} />
      <About t={t.about} />
      <Skills t={t.skills} skillsData={skillsData} />
      <Facts t={t.facts} />
    </>
  );
};

export default AboutPage;